import { Progress } from 'antd';

const logoEduzzWhite = 'https://cdn.eduzzcdn.com/blinket/eduzz-logo-v2-white.svg';
const logoEduzzDark = 'https://cdn.eduzzcdn.com/blinket/eduzz-logo-v2-dark.svg';

const GlobalLoading = () => {
  return (
    <div
      id='page-loader'
      className='fixed inset-0 z-(--uizz-antd-z-index-popup-base) flex items-center justify-center bg-(--uizz-antd-color-bg-mask) backdrop-blur-sm'
    >
      <div className='-mt-5 flex w-80 flex-col items-center justify-center'>
        <img src={logoEduzzWhite} alt='Eduzz' height={80} width={130} className='dark:hidden' />
        <img src={logoEduzzDark} alt='Eduzz' height={80} width={130} className='hidden dark:block' />
        <Progress percent={100} status='active' showInfo={false} />
      </div>
    </div>
  );
};

export default GlobalLoading;
